module.exports = __webpack_public_path__ + "img/avatar3.293bc754.png";